import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import GoogleLogin from 'react-google-login';
import {
	Menu,
	Dropdown,
	Button,
	Icon,
	message,
	Modal,
	LocaleProvider,
	Input,
	Tooltip,
} from 'antd';
import _ from 'lodash';
import languageFile from '../../../public/languages/Translation';
import urlConfig, { urlName } from '../../config/index';
import '../../../public/css/login.css';
import cookie from '../../utils/cookie';
import enUS from 'antd/lib/locale-provider/en_US';
import GetProfileDetailsAction from '../AuthorisePage/action/GetProfileDetailsAction';
import GetProfileDetailStore from '../AuthorisePage/store/GetProfileDetailStore';
import GoogleLoginAction from './action/GoogleLoginAction';
import UpdateEmailAction from './action/UpdateEmailAction';
import MicrosoftLinkAction from './action/MicrosoftLinkAction';
import MicrosoftLinkStore from './store/MicrosoftLinkStore';
import MicrosoftLoginAction from './action/MicrosoftLoginAction';
import LoginAction from './action/LoginAction';
import LoginStore from './store/LoginStore';
import SignupStore from '../SignUp/store/SignupStore';
import './style.scss';
import GetIntegrationAction from '../IntegrationControl/action/GetIntegrationAction';
import GetIntegrationStore from '../IntegrationControl/store/GetIntegrationStore';
import { googleKey2domains, googleKey3domains, googleKey4domains, googleKey5domains } from '../SignUp/domainList';
import {
	availableLanguages,
	language2letterCode,
	languageDropDown,
	languageDropDownDomains,
} from '../../utils/languageConstants';
import { languageData } from '../../utils/defaultLanguageConfig';
import getSVG from '../../utils/commonSVG';
import VerifyPage from './children/VerifyPage';
import GetWorkspaceAction from './action/GetWorkspaceAction';
import GetWorkSpaceStore from './store/GetWorkspaceStore';
import { defaultDomains } from '../../utils/defaultDomainList';

const queryString = require('query-string');

const info = Modal.info;
var moment = require('moment');

class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeClass: '',
			loginLoading: false,
			loginPassword: '',
			welcomeMessage: false,
			loginUserName: '',
			signupPassword: '',
			signupUserName: '',
			conirmPassword: '',
			currentlanguage: localStorage.getItem('language'),
			showSignup: false,
			readSettings: false,
			whiteLabelImages: {},
			languagesList: [],
			showPass: false,
			favIcon: '',
			domainIcon: '',
			domain: '',
			supportMailAddress: ''
		};
		this.onLoginResponse = this.onLoginResponse.bind(this);
		this.responseGoogle = this.responseGoogle.bind(this);
		this.microsoftLinkReceived = this.microsoftLinkReceived.bind(this);
		this.microsoftSignIn = this.microsoftSignIn.bind(this);
		this.login = this.login.bind(this);
		this.changelanguage = this.changelanguage.bind(this);
		this.onProfileDetails = this.onProfileDetails.bind(this);
		this.onLogin = this.onLogin.bind(this);
		this.userDetailsChange = this.userDetailsChange.bind(this);
		this.handleKeyPress = this.handleKeyPress.bind(this);
		this.onGetIntegrations = this.onGetIntegrations.bind(this);
	}


	componentWillMount() {
		localStorage.removeItem('firstAuthorizeLoad', 1);
		MicrosoftLinkStore.bind(this.microsoftLinkReceived);
		GetProfileDetailStore.bind(this.onProfileDetails);
		GetIntegrationStore.bind(this.onGetIntegrations);
		GetWorkSpaceStore.bind(this.getWorkSpaceResponse)
		if (localStorage.getItem('language') == null) {
			localStorage.setItem('language', 'english');
		}

		var currentLocation = this.props.location.pathname;
		if (currentLocation.indexOf('redirect') > -1) {
			var params = currentLocation.split('&'),
				// existingUserFlag = false,
				userId = '',
				profileId = '';
			params.forEach(function (item) {
				// if(item.indexOf('userExists')>-1){
				//     existingUserFlag = item.indexOf('true')>-1 ;
				// }
				if (item.indexOf('userId') > -1) {
					userId = item.split('=')[1];
				}
				if (item.indexOf('profileId') > -1) {
					profileId = item.split('=')[1];
				}
			});
			// if(!existingUserFlag){
			//     this.props.history.push('signup');
			// }else{
			cookie.createCookie('inviteeId', userId, 2);
			cookie.createCookie('profileId', profileId, 2);
			// this.setState({
			//     welcomeMessage : true,
			//     loginUserName : userId
			// })
			// }
		}
		LoginStore.bind(this.onLoginResponse);
		if (SignupStore.getSignInResponse() === 200) {
			this.setState({
				signupSuccess: true,
			});
		}
		GetIntegrationAction.getintegration(urlConfig.urlName);
	}

	componentWillUnmount() {
		MicrosoftLinkStore.unbind(this.microsoftLinkReceived);
		LoginStore.unbind(this.onLoginResponse);
		GetProfileDetailStore.unbind(this.onProfileDetails);
		GetIntegrationStore.unbind(this.onGetIntegrations);
		GetWorkSpaceStore.unbind(this.getWorkSpaceResponse)

	}

	getWorkSpaceResponse = () => {
		let response = GetWorkSpaceStore.getResponse();
		if (response.status == 200) {
			if (response.total > 1) {
				cookie.createCookie('workspaceData', JSON.stringify(response.result))
				window.location.href = '/account-overview';
			}
			else if (response.total == 1) {
				cookie.createCookie('workspaceData', JSON.stringify(response.result));
				cookie.createCookie('currentAccountId', response.result[0].accountId)
				window.location.href = '/authorize';
			}
			else {
				cookie.eraseCookie('workspaceData');
				cookie.eraseCookie('currentAccountId')
				window.location.href = '/authorize';
			}
		}
		else {
			cookie.eraseCookie('workspaceData');
			cookie.eraseCookie('currentAccountId')
			window.location.href = '/authorize';
		}
	}

	microsoftLinkReceived() {
		this.setState({
			micUrl: MicrosoftLinkStore.getResponse().url,
		});
	}
	onGetIntegrations() {
		if (GetIntegrationStore.getResponse().domainColors) {
			localStorage.setItem(
				'sidebarBackground',
				GetIntegrationStore.getResponse().domainColors.sidebarBackground
			);
			localStorage.setItem(
				'sidebarBorder',
				GetIntegrationStore.getResponse().domainColors.sidebarBorder
			);
			localStorage.setItem(
				'sidebarTransparency',
				GetIntegrationStore.getResponse().domainColors
					.sidebarTransparency
			);
			localStorage.setItem(
				'activeTabList',
				GetIntegrationStore.getResponse().domainColors.activeTabList
			);
			localStorage.setItem(
				'tabIcon',
				GetIntegrationStore.getResponse().domainColors.tabIcon
			);
			localStorage.setItem(
				'activeIcon',
				GetIntegrationStore.getResponse().domainColors.activeIcon
			);
			localStorage.setItem(
				'logoBackground',
				GetIntegrationStore.getResponse().domainColors.logoBackground
			);
			localStorage.setItem(
				'headerBackground',
				GetIntegrationStore.getResponse().domainColors.headerBackground
			);
			localStorage.setItem(
				'headerIcon',
				GetIntegrationStore.getResponse().domainColors.headerIcon
			);

			this.setState({
				domainIcon: GetIntegrationStore.getResponse().whiteLabelImages.domainIcon,
				domain: GetIntegrationStore.getResponse().whiteLabelDetails.fromName,
				supportMailAddress: GetIntegrationStore.getResponse().whiteLabelDetails.fromReviewAddress
			})
		}
		let loginImage =
			(GetIntegrationStore.getResponse().whiteLabelImages
				.loginBackground &&
				GetIntegrationStore.getResponse().whiteLabelImages
					.loginBackground +
				'?time=' +
				Date.now()) ||
			`/images/${urlConfig.urlName}/login.png`;
		let domainImage =
			(GetIntegrationStore.getResponse().whiteLabelImages.domainLogo &&
				GetIntegrationStore.getResponse().whiteLabelImages.domainLogo +
				'?time=' +
				Date.now()) ||
			`/images/${urlConfig.urlName}/login-text.png`;
		this.setState({
			showSignup: GetIntegrationStore.getResponse().signUp,
			readSettings: false,
			loginBackground: loginImage,
			domainLogo: domainImage,
			languagesList: GetIntegrationStore.getResponse().domainLanguages,
			signUpPosition:
				GetIntegrationStore.getResponse().signUpPosition || 'Default',
			marketingMessage:
				GetIntegrationStore.getResponse().marketingMessage || '',
			htmlStyle: GetIntegrationStore.getResponse().style || '',
		});

		if (GetIntegrationStore.getResponse()) {

			let domainName = urlConfig.urlName;
			document.title = GetIntegrationStore.getResponse().pageTitle ? GetIntegrationStore.getResponse().pageTitle : languageData[domainName].title;
			var meta = document.querySelector("meta[name*='description']") || document.createElement('meta');
			meta.name = 'description'
			meta.content = GetIntegrationStore.getResponse().pageDescription !== "" ? GetIntegrationStore.getResponse().pageDescription : languageData[domainName].description;
			document.getElementsByTagName('head')[0].appendChild(meta);

			// var meta = document.createElement('meta');
			// meta.name = 'description';
			// meta.content = GetIntegrationStore.getResponse().pageDescription ? GetIntegrationStore.getResponse().pageDescription :languageData.languageData[domainName].description;
			let link =
				document.querySelector("link[rel*='icon']") ||
				document.createElement('link');
			link.type = 'image/x-icon';
			link.rel = 'shortcut icon';
			link.href = GetIntegrationStore.getResponse().whiteLabelImages.favicon ? GetIntegrationStore.getResponse().whiteLabelImages.favicon + "?time=" + Date.now() : languageData[domainName].href;
			document.getElementsByTagName('head')[0].appendChild(link);
			this.setState({ favIcon: link.href })
		}
		if (this.state.signUpPosition != 'Default') {
			document.getElementById('style').innerHTML = this.state.htmlStyle;
			document.getElementById('message').innerHTML =
				this.state.marketingMessage.substring(0, 200);
		}
	}
	onProfileDetails() {
		if (GetProfileDetailStore.getResponse().status === 200) {
			localStorage.setItem(
				'masterLocationFilter',
				GetProfileDetailStore.getResponse().profile.masterLocationFilter
			);
			localStorage.setItem(
				'profileName',
				GetProfileDetailStore.getResponse().profile.profileName
			);
			localStorage.setItem(
				'favicon',
				GetProfileDetailStore.getResponse().profile.favicon
			);
			localStorage.setItem(
				'logo',
				GetProfileDetailStore.getResponse().profile.logo ||
				`/images/${urlConfig.urlName}/logo-icon.png`
			);
			localStorage.setItem(
				'logoText',
				GetProfileDetailStore.getResponse().profile.logoWithText ||
				`/images/${urlConfig.urlName}/logo-text.png`
			);
			this.redirectToTab();
		} else if (
			GetProfileDetailStore.getResponse().data &&
			GetProfileDetailStore.getResponse().data.status === 404
		) {
			this.unAuthorisedInfo();
			this.props.history.push('/login');
		} else if (
			GetProfileDetailStore.getResponse().data &&
			GetProfileDetailStore.getResponse().data.message
		) {
			message.error(GetProfileDetailStore.getResponse().data.message);
			this.props.history.push('/login');
		} else {
			message.error('something went wrong');
		}
	}
	componentDidMount() {
		MicrosoftLinkAction.getLink();
		if (cookie.readCookie('lctoken') && localStorage.getItem('profileId')) {
			this.redirectToTab();
		}

	}
	redirectToTab = () => {
		let params =
			queryString.parse(this.props.location.search) ||
			this.props.location.search;
		if (this.props.location.search.includes('?redirecturl')) {
			var url = params.redirecturl.split('managelocations/')[1];
			var newurl = '/managelocations/' + encodeURIComponent(url);
			this.props.history.push(newurl);
		} else if (this.props.location.search.includes('?reviewurl')) {
			var url = params.split('reviewurl=')[1];
			var newurl = decodeURIComponent(url);
			this.props.history.push(newurl);
		} else if (this.props.location.search.includes('?redirecttab')) {
			var url = params.redirecttab;
			var newurl = decodeURIComponent(url);
			this.props.history.push(newurl);
		} else if (this.props.location.search.includes('?reviewredirect')) {
			var url = params.reviewredirect.split('reviews/')[1];
			var newurl = '/reviews/' + decodeURIComponent(url);
			this.props.history.push(newurl);
		} else if (this.props.location.search.includes('?questionredirect')) {
			var url = params.questionredirect.split('qareviews/')[1];
			var newurl = '/qareviews/' + decodeURIComponent(url);
			this.props.history.push(newurl);
		} else if (this.props.location.search.includes('?mediaredirect')) {
			var url = params.mediaredirect.split('mediaredirect=')[1];
			var newurl = `${params.mediaredirect}&mediaId=${params.mediaId}`
			localStorage.setItem('profileId', params.profileId);
			this.props.history.push(newurl);
		}
	};

	microsoftSignIn() {
		var openWindow = window.open(
			this.state.micUrl,
			'SignIn',
			'width=600,height=400,left=400,top=200,scrollbars=1,status=0'
		);
		if (openWindow == null || typeof openWindow == 'undefined') {
			alert('Please disable your popup blocker and try again!', 3);
		}
		setInterval(() => {
			if (cookie.readCookie('micToken')) {
				MicrosoftLoginAction.login(cookie.readCookie('micToken'));
				this.props.history.push('/settings/integrations');
				cookie.eraseCookie('micToken');
			}
		}, 1000);
	}

	// onSuccess(googleUser) {
	//     // The ID token you need to pass to your backend:
	//     var id_token = googleUser.getAuthResponse().id_token;
	//     console.log("id_token", id_token)
	//     GoogleLoginAction.login(id_token)
	// },

	onFailure(error) {
		console.log('google sign in error', error);
	}

	onLoginResponse() {
		 if(LoginStore.getSignInResponse().mfaEnabled){
			localStorage.setItem('userId',LoginStore.getSignInResponse().userId )
			window.location.href = '/login/verification'
		}
		else if (LoginStore.getSignInResponse().token) {
			// var myElement = document.querySelector("#google-signin");
			// myElement.style.display = "none";
			cookie.createCookie(
				'lctoken',
				LoginStore.getSignInResponse().token,
				2
			);
			cookie.createCookie(
				'userName',
				LoginStore.getSignInResponse().name,
				2
			);
			cookie.createCookie(
				'userId',
				LoginStore.getSignInResponse().userId,
				2
			);

			if (
				cookie.readCookie('inviteeId') &&
				cookie.readCookie('inviteeId') !== cookie.readCookie('userId')
			) {
				UpdateEmailAction.update({
					profileId: cookie.readCookie('profileId'),
					invitedEmail: cookie.readCookie('inviteeId'),
					loginEmail: cookie.readCookie('userId'),
				});
				cookie.eraseCookie('inviteeId');
				cookie.eraseCookie('profileId');
			}
			//it will work when inbox tab active
			if (
				this.props.location.search.includes('?redirecturl') ||
				this.props.location.search.includes('?reviewurl') ||
				this.props.location.search.includes('?redirecttab') ||
				this.props.location.search.includes('?reviewredirect') ||
				this.props.location.search.includes('?questionredirect') ||
				this.props.location.search.includes('?mediaredirect')
			) {
				// if (Object.prototype.hasOwnProperty.call(this.props.location.search, 'redirecturl')) {
				localStorage.setItem(
					'profileId',
					this.props.location.search.split('&profileId=')[1]
				);
				GetProfileDetailsAction.getProfileDetails(
					this.props.location.search.split('&profileId=')[1],
					urlName
				);
			} else {
				if (this.props.location.state && this.props.location.state.from)
					window.location.href = `${this.props.location.state.from.pathname}${this.props.location.state.from.search}`;
				else if(defaultDomains.includes(urlName)) {

					GetWorkspaceAction.getWorkspace()
				}
				else{
					window.location.href = '/authorize';
				}
				// window.location.href = '/authorize';

				// else window.location.href = '/authorize';
			}
		} else if (
			LoginStore.getSignInResponse().status &&
			LoginStore.getSignInResponse().status !== 200
		) {
			if (
				LoginStore.getSignInResponse().status === 401 &&
				LoginStore.getSignInResponse().data.subCode === 2
			) {
				this.setState({
					loginError: true,
					errorMessage:
						'You have exceeded the maximum number of failed login attempts. Please try after 30 minutes.',
				});
			}
			if (
				LoginStore.getSignInResponse().status === 401 &&
				LoginStore.getSignInResponse().data.subCode === 3
			) {
				this.setState({
					loginError: true,
					errorMessage: 'Please verify your email address',
				});
			} else {
				this.setState({
					loginError: true,
					errorMessage: 'Invalid email or password.',
				});
			}
		}
		this.setState({
			loginLoading: false,
		});
	}

	handleKeyPress(e) {
		if (e.key === 'Enter') {
			this.onSignIn();
		}
	}

	userDetailsChange(field, event) {
		var userDetails = {};
		userDetails[field] = event.target.value;
		this.setState(userDetails);
	}

	onLogin(e) {
		if (e.key === 13 || e.key === 'Enter') {
			this.login();
		}
	}

	login() {
		var urlName = urlConfig.urlName;
		this.setState({
			loginError: false,
			loginLoading: true,
		});
		LoginAction.login({
			userId: this.state.loginUserName,
			password: this.state.loginPassword,
			domainName: urlName,
		});
	}
	responseGoogle(params) {
		// console.log('login', params.getAuthResponse().id_token)
		var id_token = params.getAuthResponse().id_token;
		// console.log("id_token", id_token)
		GoogleLoginAction.login(id_token);
	}
	changelanguage(e) {
		localStorage.setItem('language', e);
		this.setState({
			currentlanguage: e,
		});
	}
	unAuthorisedInfo() {
		info({
			title: "You don't have permission to view this page!",
			content:
				"You don't have access to this profile. Please contact the profile admin to get access.",
		});
	}
	googleLoginButton = () => {
		if (googleKey2domains.indexOf(urlConfig.urlName) > -1) {
			return (
				<GoogleLogin
					clientId='897799599212-5kq3v9n461etdif7n9pkusuupjbumi7n.apps.googleusercontent.com'
					buttonText='Google'
					onSuccess={this.responseGoogle}
					onFailure={this.responseGoogle}
				/>
			);
		} else if (googleKey3domains.indexOf(urlConfig.urlName) > -1) {
			return (
				<GoogleLogin
					clientId='999213825609-6nun3lirf4ck320fkofbhufv28fagjei.apps.googleusercontent.com'
					buttonText='Google'
					onSuccess={this.responseGoogle}
					onFailure={this.responseGoogle}
				/>
			);
		}
		else if (googleKey4domains.indexOf(urlConfig.urlName) > -1) {
			return (
				<GoogleLogin
					// clientId='198165534094-4g51cndfj65rfihcu8in1e87ekf0kacm.apps.googleusercontent.com'
					clientId='999213825609-6nun3lirf4ck320fkofbhufv28fagjei.apps.googleusercontent.com'
					buttonText='Google'
					onSuccess={this.responseGoogle}
					onFailure={this.responseGoogle}
				/>
			);
		}
		else if (googleKey5domains.indexOf(urlConfig.urlName) > -1) {
			return (
				<GoogleLogin
					clientId='486505790061-9eogh793gfm8e46bnonaeo7gccshsdof.apps.googleusercontent.com'
					buttonText='Google'
					onSuccess={this.responseGoogle}
					onFailure={this.responseGoogle}
				/>
			);
		}
		else {
			return (
				<GoogleLogin
					clientId='1043781443422-m2m8c319grmtoufkjqfsq3p0nd74tvun.apps.googleusercontent.com'
					buttonText='Google'
					onSuccess={this.responseGoogle}
					onFailure={this.responseGoogle}
				/>
			);
		}
	};

	domainLogoLoaded = (event) => {
		const target = (event && event.target) || {};
		if (target.style) {
			target.style.opacity = 1;
		}
	}

	domainLogoNotLoaded = (event) => {
		const target = (event && event.target) || {};
		if (target.style) {
			target.style.opacity = 0;
		}
	}
	changePassVisibility = () => {
		this.setState({ showPass: !this.state.showPass })
	}
	render() {
		var urlName = urlConfig.urlName;
		let loginBackGround = `url(${this.state.loginBackground})`;
		let domainLogo = this.state.domainLogo;
		const menu = (
			<Menu onClick={(e) => this.changelanguage(e.item && e.item.props && e.item.props.value && e.item.props.value)}>
				{_.map(languageDropDown, (item, key) => {
					if (this.state.languagesList.includes(item.value)) {
					return <Menu.Item key={item.value} value={item.value}>{item.label}</Menu.Item>;
					}
				})}
			</Menu>
		);
		if (localStorage.getItem('language') === 'portuguese') {
			moment.locale('pt');
		} else if (localStorage.getItem('language') === 'english') {
			moment.locale('en');
		} else if (localStorage.getItem('language') === 'german') {
			moment.locale('de');
		} else if (localStorage.getItem('language') === 'spanish') {
			moment.locale('es');
		} else if (localStorage.getItem('language') === 'french') {
			moment.locale('fr');
		} else if (localStorage.getItem('language') === '日本語') {
			moment.locale('ja');
		}

		if (this.state.signupSuccess) {
			return <VerifyPage domainIcon={this.state.domainIcon} domain={this.state.domain} />

			// return (
			// 	<div className='login-verification'>
			// 		<div className='verification-block'>
			// 			<div className='logo'>
			// 				<span>
			// 					<img src={`/images/${urlName}/logo-icon.png`} />
			// 				</span>
			// 			</div>
			// 			<h3>Verify your account to get started!</h3>
			// 			<p>
			// 				We have sent you an email with the link to verify
			// 				your account. Use the link to login to {urlName} and
			// 				start managing reviews, viewing insights, and more!
			// 			</p>
			// 		</div>
			// 	</div>
			// );
		}

		return (
			<LocaleProvider locale={enUS}>
				<div className='user-credentials'>
					{this.state.signUpPosition == 'Right' && (
						<div className='user-info'>
							<div className='user-content' id='style'></div>
						</div>
					)}
					{this.state.signUpPosition == 'Default' && (
						<div
							className='user-info'
							style={{ backgroundImage: loginBackGround }}>
							<div className='info-conent'>
								<div className='login-logo'>
									<img src={domainLogo} onError={this.domainLogoNotLoaded} onLoad={this.domainLogoLoaded} />
								</div>
							</div>
						</div>
					)}
					{(this.state.signUpPosition == 'Default' ||
						this.state.signUpPosition == 'Right' ||
						this.state.signUpPosition == 'Left') && (
							<div className='user-details'>
								<div className='signup-wrap'>
									{this.state.showSignup && (
										// <span className='signup-text'>
										// 	<span>
										// 		{
										// 			languageFile[
										// 				localStorage.getItem(
										// 					'language'
										// 				)
										// 			]['12729']
										// 		}{' '}
										// 	</span>
										// 	<Link to='/signup'>
										// 		{
										// 			languageFile[
										// 				localStorage.getItem(
										// 					'language'
										// 				)
										// 			]['13840']
										// 		}
										// 	</Link>
										// </span>
										<></>
									)}
								</div>

								{this.state.signUpPosition != 'Default' && (
									<div className='marketting-message'>
										<div id='message' />
									</div>
								)}
								<div className='user-details__inner'>
									<div className='fav-icon-class'>
										<img src={this.state.domainIcon}></img>
									</div>
									<div className='language-selector'>
										<div>
											<h3>
												{
													languageFile[
													localStorage.getItem('language')
													]['2062']
												}

											</h3>
											<span className='signup-text'>
												<span>
													{
														languageFile[
														localStorage.getItem(
															'language'
														)
														]['2064']
													}{' '}
												</span>
												<Link to='/signup'>
													{
														languageFile[
														localStorage.getItem(
															'language'
														)
														]['13840']
													}
												</Link>
											</span>
										</div>
										{languageDropDownDomains.indexOf(urlName) >
											-1 && (
												<Dropdown overlay={menu}>
													<span>
														<div className='translation-icon'>
															{language2letterCode[localStorage.getItem('language')]}
															{getSVG('translate')}
														</div>
													</span>
												</Dropdown>
											)}
									</div>
									<ul>
										{/*{this.state.signupSuccess&&<li>
                                                                                                                                                                                                                                                                                                        <span style={{fontSize: '14px', color: 'green'}}>Account created successfully! Please login.</span>
                                                                                                                                                                                                                                                                                                    </li>}*/}
										{this.state.welcomeMessage && (
											<li>
												<span
													style={{
														fontSize: '14px',
														color: 'green',
													}}>
													{' '}
													Seems like you are already
													registered. Simply login to gain
													access to the profile you've
													been invited to share.
												</span>
											</li>
										)}
										<li>
											<div className='label-block'>{
												languageFile[
												localStorage.getItem('language')
												]['2063']
											}*</div>

											<Input
												placeholder={
													languageFile[
													localStorage.getItem(
														'language'
													)
													]['10935']
												}
												onChange={this.userDetailsChange.bind(
													this,
													'loginUserName'
												)}
												value={this.state.loginUserName}
											/>
											{/* <span className='highlight'></span> */}
											{/* <span className='bar'></span> */}
										</li>
										<li>
											<div className='label-block'>{languageFile[
												localStorage.getItem(
													'language'
												)
											]['13123']}*</div>
											<Input
												type={this.state.showPass ? 'text' : 'password'}
												placeholder={
													languageFile[
													localStorage.getItem(
														'language'
													)
													]['13123']
												}
												onChange={this.userDetailsChange.bind(
													this,
													'loginPassword'
												)}
												value={this.state.loginPassword}
												onKeyPress={this.onLogin}
												suffix={
													!this.state.showPass ? <span style={{ cursor: 'pointer' }} onClick={() => this.changePassVisibility()}>
														<Tooltip title={
															languageFile[
															localStorage.getItem(
																'language'
															)
															]['2070']
														}>
															<svg viewBox="64 64 896 896" focusable="false" data-icon="eye" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"></path></svg></Tooltip>
													</span> :
														<span style={{ cursor: 'pointer' }} onClick={() => this.changePassVisibility()}>
															<Tooltip title={
																languageFile[
																localStorage.getItem(
																	'language'
																)
																]['2071']
															}>
																<svg viewBox="64 64 896 896" focusable="false" data-icon="eye-invisible" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z"></path><path d="M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z"></path></svg>
															</Tooltip></span>
												}
											/>
											{/* <span className='highlight'></span>
										<span className='bar'></span> */}
										</li>
										<li>
											{/* <button onClick={this.login} >
										{this.state.loginLoading &&<span>
												 (
													<Icon type='loading' />
												)
											</span>}
											<span>
												{
													languageFile[
														localStorage.getItem(
															'language'
														)
													]['12377']
												}
											</span>
										</button> */}
											<Button onClick={this.login} loading={this.state.loginLoading}>
												{
													languageFile[
													localStorage.getItem(
														'language'
													)
													]['12377']
												}
											</Button>
										</li>
										{this.state.loginError && (
											<li>
												<span className='error-message'>
													{this.state.errorMessage}
												</span>
											</li>
										)}
										<li>
											<span className='signup-text'>
												<Link to='/forgotPassword'>
													{
														languageFile[
														localStorage.getItem(
															'language'
														)
														]['11126']
													}
												</Link>
											</span>
										</li>
										<li className='login-division'>
											<div className='login-with'>Or</div>
										</li>
									</ul>
									<div className='login-social'>
										<div className='google-btn'>
											{this.googleLoginButton()}
										</div>
										{/* {this.state.micUrl &&
                                    <div className="micro-soft__btn">
                                        <a id="SignIn" onClick={this.microsoftSignIn}>
                                            <span className="microsoft-icon"></span> Microsoft
                                        </a>
                                    </div>} */}
									</div>
								</div>
							</div>
						)}
					{this.state.signUpPosition == 'Left' && (
						<div className='user-info'>
							<div className='user-content'>
								<div id='style' />
							</div>
						</div>
					)}
				</div>
			</LocaleProvider>
		);
	}
}

export default Login;
